import { Controller } from '@hotwired/stimulus'
import { DataTable } from 'simple-datatables'

export default class extends Controller {
  static targets = ['table']
  static values = {
    searchable: Boolean,
    sortable: Boolean,
    fixedHeight: Boolean,
    paging: Boolean,
    perPage: Number,
    perPageSelect: Array,
  }

  connect() {
    this.dataTable = new DataTable(this.tableTarget, {
      searchable: this.hasSearchableValue ? this.searchableValue : true,
      sortable: this.hasSortableValue ? this.sortableValue : true,
      fixedHeight: this.hasFixedHeightValue ? this.fixedHeightValue : false,
      paging: this.hasPagingValue ? this.pagingValue : true,
      perPage: this.hasPerPageValue ? this.perPageValue : 100,
      perPageSelect: this.hasPerPageSelectValue
        ? this.perPageSelectValue
        : [[100], [50], [20], [10]],
    })
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable.destroy()
    }
  }

  refresh() {
    if (this.dataTable) {
      this.dataTable.refresh()
    }
  }
}
